export default "__VITE_ASSET__CMxOzhmI__"